module.exports = __webpack_public_path__ + "img/keeper_of_the_light.80ae32b7.png";